/**
 * Detects if the current platform is macOS.
 * Uses the modern navigator.userAgentData API when available,
 * with fallback to the deprecated navigator.platform and userAgent string.
 */
export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') return false;

  // Check userAgent string first (covers Playwright user-agent overrides and general detection)
  if (navigator.userAgent) {
    const ua = navigator.userAgent;
    // Explicitly non-Mac platforms
    if (/Linux|Windows|Android|X11/.test(ua) && !/Mac/.test(ua)) {
      return false;
    }
  }

  // Modern API (Chrome 90+, Edge 90+, Opera 76+)
  if ((navigator as any).userAgentData?.platform) {
    return (navigator as any).userAgentData.platform.toLowerCase().includes('mac');
  }

  // Fallback for browsers without userAgentData support (Safari, Firefox)
  return navigator.platform?.toUpperCase().includes('MAC') ?? false;
}
